import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';

export const SAVE_DRAFT_FAIL = 'DRAFT :: SAVE_FAIL';

export type TSaveDraftFailAction = IReduxAction<typeof SAVE_DRAFT_FAIL>;

export const saveDraftFail = actionGenerator<typeof SAVE_DRAFT_FAIL>(SAVE_DRAFT_FAIL);
